// Single source of truth for the Terms of Service "last updated" date and any pending
// change notice. TermsPage.tsx and TermsUpdateBanner.tsx both read from here.
//
// When shipping a "significant" Terms change (pricing, liability, data use, dispute
// resolution — anything that makes a user's position worse, see section11's 30-day-notice
// promise): set `pendingChange` below with the real effective date, at least 30 days out.
// The banner will start showing site-wide immediately. On the effective date, update the
// actual Terms content in TermsPage.tsx, move `lastUpdated` to that date, and set
// `pendingChange` back to null.
export const TERMS_META = {
  lastUpdated: 'June 30, 2026',
  pendingChange: null as null | {
    effectiveDate: string; // display string, e.g. 'September 17, 2026'
    summary: string;       // one-line plain-English description shown in the banner
  },
};
